export default __webpack_public_path__ + "static/media/linkIcon.8a4847a9.svg";